import { render, staticRenderFns } from "./WebhooksTab.vue?vue&type=template&id=155abab2&scoped=true&"
import script from "./WebhooksTab.vue?vue&type=script&lang=js&"
export * from "./WebhooksTab.vue?vue&type=script&lang=js&"
import style0 from "./WebhooksTab.vue?vue&type=style&index=0&id=155abab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155abab2",
  null
  
)

export default component.exports